export const text =
  '【6月22日｜TiDB 地区交流活动（武汉站）开启报名！】和 TiDB 社区版主、TiCDC 研发负责人、TiDB 元老级用户一起聊聊“传统vs分布式｜分布式数据库 TiDB 的优势场景和未来趋势”';
export const link = 'https://asktug.com/t/topic/1027063';
